import * as React from 'react';

import ManageUsers32 from './ManageUsers32';

export const manageUsers32 = () => <ManageUsers32 />;

export default {
    title: 'Icon/Logo/ManageUsers32',
    component: ManageUsers32,
    parameters: {
        notes: "`import ManageUsers32 from 'box-ui-elements/es/icon/logo/ManageUsers32';`",
    },
};
